import { useRef } from 'react';

var useConst = function useConst(ctor) {
  /* Create a ref of the matching type. */
  var ref = useRef();
  /* If the ref hasn't been initialized, initialize it. */

  if (!ref.current) ref.current = ctor();
  /* Return the ref's value. */

  return ref.current;
};

export { useConst };
